import  gql  from 'graphql-tag'

export const PROCESS_USER_STATUS = gql`mutation ProcessUserStatus($input: ProcessUserStatusInput!){
  userStatus(input: $input){
    success
  }
}`;
